import { alpha } from '@mui/system';

const palette = {
  info: {
    main: '#696000',
    dark: '#363100',
    light: '#9F9300',
    contrastText: '#fff'
  },
  overlay: {
    main: '#FFFFFF',
    dark: '#000000',
    light: '#FFFFFF',
    contrastText: '#FFFFFF'
  },
  success: {
    main: '#3CCC7E',
    dark: '#00522A',
    light: '#7BC6A2',
    contrastText: '#fff'
  },
  error: {
    main: '#ED3B3B',
    dark: '#B00000',
    light: '#FE8C8C',
    contrastText: '#fff'
  },
  warning: {
    main: '#ED8F02',
    dark: '#C77700',
    light: '#FFB547',
    contrastText: '#fff'
  },
  mode: 'light',
  primary: {
    main: '#4F6600',
    dark: '#273500',
    light: '#D7FF60',
    contrastText: '#3B4D00'
  },
  secondary: {
    main: '#6684FF',
    dark: '#384165',
    light: '#8BA2FF',
    contrastText: '#fff'
  },
  action: {
    active: '#D1D5DB',
    hover: '#0000000A',
    selected: '#00000014',
    disabled: '#00000042',
    disabledBackground: '#0000001F',
    focus: '#0000001F'
  },
  background: {
    creator: '#f7f8f2',
    paper: '#f3f4f2',
    dark: '#161f00',
    light: '#fff'
  },
  text: {
    primary: '#000000DE',
    secondary: '#00000099',
    disabled: '#00000061',
    contrast: '#fff'
  },
  other: {
    divider: '#E0E0E0',
    outlineBorder: alpha('#000', 0.23),
    standardInputLine: '#0000006B'
  }
};

export { palette };
